import React, { useContext } from "react";
import { Select } from "antd";

import { GeralContext } from "../../ContextProvider";

import { getLabel } from "../../../shared/utils/labelConfig";

const { Option } = Select;

const SelectDisciplinas = ({ disciplinaId, disciplinas, onChange, visible, semOpcaoTodos }) => {
    const context = useContext(GeralContext);

    const canalId = parseInt(localStorage.getItem("entidade_id"));
    const nivelEnsino = context.nivelEnsino;
    const labelDisciplina = getLabel("visaoGeralTabela", { canalId, nivelEnsino });

    return (
        <>
            {visible && (
                <Select
                    className="filter"
                    placeholder={`Selecionar ${labelDisciplina}`}
                    name="disciplinas"
                    allowClear={true}
                    onChange={onChange}
                    disabled={disciplinas.length === 0}
                    {...(disciplinaId != null && { value: disciplinaId })}
                >
                    {!semOpcaoTodos && <Option value="Todos">Todos</Option>}
                    {disciplinas.map(disciplina => (
                        <Option key={disciplina.id} value={disciplina.id}>
                            {disciplina.nome}
                        </Option>
                    ))}
                </Select>
            )}
        </>
    );
};

export default SelectDisciplinas;
